import { render } from "./Recruitments.vue?vue&type=template&id=2558f69d"
import script from "./Recruitments.vue?vue&type=script&lang=js"
export * from "./Recruitments.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__